import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import AppLayout from "../layout/app-layout";
import { checkToken, checkUserToken } from "../redux/slices/authSlice";
import AuthViews from "./auth-views";
import ClinicLogin from "./auth-views/clinic-login";
import LoginPage from "./auth-views/Login";
import Register from "./auth-views/Register";
import UserLogin from "./auth-views/UserLogin";
import EvetLogin from "./auth-views/evet-login";

const Views = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.authSlice.token);
  const userToken = useSelector((state) => state.authSlice.userToken);

  useEffect(() => {
    dispatch(checkUserToken());
    dispatch(checkToken());
  }, []);

  return (
    <Routes>
      {token === null && userToken === null ? (
        <Route path="/" element={<AuthViews />}>
          <Route index element={<LoginPage />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="user-login" element={<UserLogin />} />
          <Route path="clinic-login" element={<ClinicLogin />} />
          <Route path="evet-login" element={<EvetLogin />} />
          <Route path="register" element={<Register />} />
          <Route path="*" element={<LoginPage />} />
        </Route>
      ) : (
        <React.Fragment>
          <Route path="/*" element={<AppLayout />}></Route>
        </React.Fragment>
      )}
    </Routes>
  );
};

export default Views;
